import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import { environmentLookupFn } from '../../../environment/environment-instance';
import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';
import type {
  Coupon,
  CustomerVariables,
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);

const DEFAULT_CONFIG = {};


export function useGetCouponStringForSignup(
  dataLocator: CustomerVariables,
  config: FetchAndRefetchConfig<Coupon, CustomerVariables> = DEFAULT_CONFIG
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);

  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);

  const { fetch: fetchConfig, refetch } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    Coupon[] | undefined,
    unknown,
  ];
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const read = useCallback((
    param: ReadParameters<CustomerVariables> = {},
    requestConfig?: ReadRequestConfig<Coupon, CustomerVariables>,
    ...rest: Array<ReadRequestConfig<Coupon, CustomerVariables> | undefined>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig, ...rest);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
